// src/components/Can.js
//
// Phase 0B frontend gating helper. Renders `children` only when the current
// user's permission set (from PermissionContext) grants the given
// module/action — used for action-button visibility and section gating.
//
// IMPORTANT: this is a UX convenience only, per the backend's authoritative
// middlewares/authorize.js. A hidden button here is not a security control;
// removing/tampering with the frontend does not grant access, because the
// corresponding API route re-checks the same permission server-side.
//
// Per the explicit instruction not to hide ALL UI just because permissions
// are still loading: while `loading` is true, this renders nothing extra
// (no spinner, no flash-then-hide) rather than optimistically showing the
// gated content — the rest of the page/layout around it is unaffected since
// this only wraps the specific gated fragment, not the whole page.
import { usePermissions } from "../context/PermissionContext";

export default function Can({ moduleKey, actionKey, any, fallback = null, children }) {
  const { can, canAny, loading } = usePermissions();

  if (loading) return null;

  const allowed = any ? canAny(any) : can(moduleKey, actionKey);

  return allowed ? children : fallback;
}
